<template>
  <div class="vux-slider" :class="classes">
    <div class="vux-swiper" :style="{height: xheight}">
      <slot></slot>
      <div class="vux-swiper-item" v-for="(item, index) in list" @click="clickListItem(item)" :data-index="index">
        <a href="javascript:">
          <div class="vux-img" :style="{backgroundImage: buildBackgroundUrl(item[imgKey])}"></div>
          <p class="vux-swiper-desc" v-if="showDescMask">{{item[titleKey]}}</p>
        </a>
      </div>
    </div>
    <div :class="[dotsClass, 'vux-indicator', 'vux-indicator-' + dotsPosition]" v-show="showDots">
      <a href="javascript:" v-for="key in length">
        <i class="vux-icon-dot" :class="{'active': key === current+1}"></i>
      </a>
    </div>
  </div>
</template>

<script>
import Swiper from './swiper'
import { go } from '../../libs/router'

export default {
  mounted () {
    if (!(this.list && this.list.length === 0)) {
      this.render()
    }
    this.xheight = this.getHeight()
  },
  methods: {
    clickListItem (item) {
      go(item[this.urlKey], this.$router)
      this.$emit('on-click-list-item', JSON.parse(JSON.stringify(item)))
    },
    buildBackgroundUrl (url) {
      return `url(${url})`
    },
    render () {
      this.swiper && this.swiper.destroy()
      this.swiper = new Swiper({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      })
        .on('swiped', (prev, index) => {
          this.current = index % this.length
        // this.index = index % this.length
        })
    },
    rerender () {
      if (!this.$el) {
        return
      }
      this.$nextTick(() => {
        // this.index = 0
        this.current = 0
        this.length = this.list.length || this.$children.length
        this.destroy()
        this.render()
      })
    },
    destroy () {
      this.swiper && this.swiper.destroy()
    },
    getHeight () {
      // when list.length > 0, it's better to set height or ratio
      const hasHeight = parseInt(this.height, 10)
      if (hasHeight) return this.height
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px'
        }
        return '180px'
      }
    }
  },
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: {
      type: Boolean,
      default: false
    },
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    // index: {
    //   type: Number,
    //   default: 0
    // },
    value: {
      type: Number,
      default: 0
    },
    imgKey: {
      type: String,
      default: 'img'
    },
    urlKey: {
      type: String,
      default: 'url'
    },
    titleKey: {
      type: String,
      default: 'title'
    },
    cssClasses: String
  },
  data () {
    return {
      // current: this.index,
      current: this.value,
      xheight: 'auto',
      length: this.list.length
    }
  },
  watch: {
    list (val) {
      this.rerender()
    },
    current (currentIndex) {
      this.$emit('on-index-change', currentIndex)
      this.$emit('input', currentIndex)
    },
    value (val) {
      if (val !== this.current) {
        this.$nextTick(() => {
          this.swiper.go(val)
        })
      }
    }
  },
  computed: {
    classes() {
      return this.cssClasses
    }
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>

<style lang="less">
@import '../../styles/cui/widget/cui_cell/cui_cell_global';
@pre: vux;

.@{pre}-slider {
  overflow: hidden;
  position: relative;

  > .@{pre}-indicator, .@{pre}-indicator-right {
    position: absolute;
    right: 15/@w;
    bottom: 10/@w;

    > a {
      float: left;
      margin-left: 6/@w;
      &:first-child{
        margin-left: 0;
      }

      > .@{pre}-icon-dot {
        display: inline-block;
        vertical-align: middle;
        width: 6/@w;
        height: 6/@w;
        border-radius: 50%;
        background-color: #d0cdd1;
      }
      > .@{pre}-icon-dot.active {
        background-color: #04BE02;
      }

    }
  }

  > .@{pre}-indicator-center {
    right: 50%;
    transform: translateX(50%)
  }

  > .@{pre}-indicator-left {
    left: 15/@w;
    right: auto;
  }

  > .@{pre}-swiper {
    overflow: hidden;
    position: relative;

    > .@{pre}-swiper-item {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      > a {
        display: block;
        width: 100%;
        height: 100%;

        > .@{pre}-img {
          display: block;
          width: 100%;
          height: 100%;
          background: center center no-repeat;
          background-size: cover;
        }

        > .@{pre}-swiper-desc {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 18/@w;
          font-size: 16/@w;
          padding: 20/@w 50/@w 12/@w 13/@w;
          margin: 0;
          background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, .7) 100%);
          color: #fff;
          text-shadow: 0 1px 0 rgba(0, 0, 0, .5);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-wrap: normal;
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// swiper.vue?54cd7dca